import Home from '../views/Home/Index.vue'

import Error404 from '../views/Error404/Index.vue'

/// compilation of all routes into an variable
export default {
    children: [
        {
            path: '/', component: Home,
            meta: {
                routeName: 'home_page',
                title: 'Raizzon Infotech LLP',
                keywords: 'Easy Tailor App, Twisted Sugar, Activz',
                description: 'Mobile Apps, Cloud Solutions, ERP solutions',
                socialImage: 'https://twistedsugar.com/assets/images/twisted-sugar-logo.png'
            }
        },
        {
            path: '/*', component: Error404,
            meta: {
                routeName: 'error_page',
                title: 'Page Not Found',
                keywords: 'Twisted Sugar, Cookies, Sodas, Twisters',
                description: 'Treat yourself with goodness of Twisted Sugar Cookies',
                socialImage: 'https://twistedsugar.com/assets/images/twisted-sugar-logo.png'
            }
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/routes.js